import React, { Fragment, useEffect, useState } from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";
import ChartBar from "../../charts/ChartBar";
import MultipleRadialBar from "../../charts/MultipleRadialBar";
import PieChart from "../../charts/PieChart";
import SplineChart from "../../charts/SplineChart";
import JobAgeing from "../../charts/JobAgeing";
import * as constants from "../../../utils/Constants";

const Statistics = () => {
  const [statistics, setStatistics] = useState({});
  const [topCompanies, setTopCompanies] = useState({});
  const [topRecruitersNameByCandidate, setTopRecruitersNameByCandidate] =
    useState([]);
  const [topRecruitersPercentByCandidate, setTopRecruitersPercentByCandidate] =
    useState([]);
  const [topRecruitersNameByRevenue, setTopRecruitersNameByRevenue] = useState(
    []
  );
  const [topRecruitersPercentByRevenue, setTopRecruitersPercentByRevenue] =
    useState([]);
  const [topInternalNameByCandidate, setTopInternalNameByCandidate] = useState(
    []
  );
  const [topInternalPercentByCandidate, setTopInternalPercentByCandidate] =
    useState([]);
  const [topIndustries, setTopIndustries] = useState({});
  const [higherRevenue, setHigherRevenue] = useState({});
  const [higherBackout, setHigherBackout] = useState({});
  const [jobData, setJobData] = useState({});
  const [monthlyRevenueGenerated, setMonthlyRevenueGenerated] = useState({});
  const [dailyJobData, setDailyJobData] = useState({});
  const [isDailyJobData, setIsDailyJobData] = useState(false);
  const [monthlyJobData, setMonthlyJobData] = useState({});
  const [monthlyCvData, setMonthlyCvData] = useState({});
  const [monthlyCandidateJoinedData, setMonthlyCandidateJoinedData] = useState(
    {}
  );
  const [dailyCvData, setDailyCvData] = useState([]);
  const [isDailyCvData, setIsDailyCvData] = useState(false);
  const [dailyCvByIRData, setDailyCvByIRData] = useState({});
  const [isDailyCvByIr, setIsDailyCvByIr] = useState(false);
  const [years, setYears] = useState([]);
  const [yearByJob, setYearByJob] = useState("");
  const [monthByJob, setMonthByJob] = useState("");
  const [yearByAgent, setYearByAgent] = useState("");
  const [monthByAgent, setMonthByAgent] = useState("");
  const [yearByIr, setYearByIr] = useState("");
  const [monthByIr, setMonthByIr] = useState("");

  const [recruitersMonthByCandidate, setRecruitersMonthByCandidate] =
    useState("");
  const [recruitersYearByCandidate, setRecruitersYearByCandidate] =
    useState("");
  const [isRecruiterByCandidate, setIsRecruiterByCandidate] = useState(false);

  const [recruitersMonthByRevenue, setRecruitersMonthByRevenue] = useState("");
  const [recruitersYearByRevenue, setRecruitersYearByRevenue] = useState("");
  const [isRecruiterByRevenue, setIsRecruiterByRevenue] = useState(false);

  const [internalMonthByCandidate, setInternalMonthByCandidate] = useState("");
  const [internalYearByCandidate, setInternalYearByCandidate] = useState("");
  const [isInternalByCandidate, setIsInternalByCandidate] = useState(false);

  const loggedInUser = JSON.parse(localStorage.getItem("user"));
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
    fetch(constants.GetDashboardDataUrl, {
      headers: {
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
    })
      .then((response) => response.json())
      .then((res) => {
        setStatistics(res.data);
      });

    fetch(constants.GetJobAnalyticsUrl, {
      headers: {
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
    })
      .then((response) => response.json())
      .then((res) => {
        setJobData(res.data);
      });

    fetch(
      `${constants.GetMonthlyJobAnalyticsUrl}?year=${new Date().getFullYear()}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${loggedInUser.sessionToken}`,
        },
      }
    )
      .then((response) => response.json())
      .then((res) => {
        setMonthlyJobData(res.data);
      });

    fetch(
      `${
        constants.GetMonthlyCandidateAnalyticsUrl
      }?year=${new Date().getFullYear()}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${loggedInUser.sessionToken}`,
        },
      }
    )
      .then((response) => response.json())
      .then((res) => {
        setMonthlyCvData(res.data);
      });

    fetch(constants.GetMonthyRevenueGenerateUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
    })
      .then((response) => response.json())
      .then((res) => {
        setMonthlyRevenueGenerated(res.data);
      });

    fetch(
      `${constants.GetDailyCvAnalyticsUrl}?month=${
        new Date().getMonth() + 1
      }&year=${new Date().getFullYear()}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${loggedInUser.sessionToken}`,
        },
      }
    )
      .then((response) => response.json())
      .then((res) => {
        setDailyCvData(res.data);
      });

    fetch(
      `${constants.GetDailyCvByIRUrl}?month=${
        new Date().getMonth() + 1
      }&year=${new Date().getFullYear()}&role=IR`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${loggedInUser.sessionToken}`,
        },
      }
    )
      .then((response) => response.json())
      .then((res) => {
        setDailyCvByIRData(res.data);
      });

    fetch(constants.TopCompanyNamesUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
    })
      .then((response) => response.json())
      .then((res) => {
        setTopCompanies(res.data);
      });

    fetch(
      `${constants.TopRecruitersByCandidateUrl}?month=${
        new Date().getMonth() + 1
      }&year=${new Date().getFullYear()}&topBy=candidateJoined`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${loggedInUser.sessionToken}`,
        },
      }
    )
      .then((response) => response.json())
      .then((res) => {
        var name = [];
        var percent = [];
        if (res?.data) {
          res?.data.map((rec) => name.push(rec.name));
          res?.data.map((rec) => percent.push(rec.percentage));
        }
        setTopRecruitersNameByCandidate(name);
        setTopRecruitersPercentByCandidate(percent);
      });

    fetch(
      `${constants.TopRecruitersByCandidateUrl}?month=${
        new Date().getMonth() + 1
      }&year=${new Date().getFullYear()}&topBy=revenueGenerated`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${loggedInUser.sessionToken}`,
        },
      }
    )
      .then((response) => response.json())
      .then((res) => {
        var name = [];
        var percent = [];
        if (res?.data) {
          res?.data.map((rec) => name.push(rec.name));
          res?.data.map((rec) => percent.push(rec.percentage));
        }
        setTopRecruitersNameByRevenue(name);
        setTopRecruitersPercentByRevenue(percent);
      });

    fetch(
      `${constants.TopInternalByCandidateUrl}?month=${
        new Date().getMonth() + 1
      }&year=${new Date().getFullYear()}&topBy=candidateJoined`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${loggedInUser.sessionToken}`,
        },
      }
    )
      .then((response) => response.json())
      .then((res) => {
        var name = [];
        var percent = [];
        if (res?.data) {
          res?.data.map((rec) => name.push(rec.name));
          res?.data.map((rec) => percent.push(rec.percentage));
        }
        setTopInternalNameByCandidate(name);
        setTopInternalPercentByCandidate(percent);
      });

    fetch(constants.TopIndustriesUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
    })
      .then((response) => response.json())
      .then((res) => {
        setTopIndustries(res.data);
      });

    fetch(
      `${constants.GetDailyJobDataUrl}?month=${
        new Date().getMonth() + 1
      }&year=${new Date().getFullYear()}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${loggedInUser.sessionToken}`,
        },
      }
    )
      .then((response) => response.json())
      .then((res) => {
        setDailyJobData(res.data);
      });

    fetch(constants.CompaniesWithHigherRevenueUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
    })
      .then((response) => response.json())
      .then((res) => {
        setHigherRevenue(res.data);
      });

    fetch(constants.RecruitersWithHighBackout, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
    })
      .then((response) => response.json())
      .then((res) => {
        setHigherBackout(res.data);
      });

    fetch(constants.GetMonthlyCandidatesJoinedUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
    })
      .then((response) => response.json())
      .then((res) => {
        setMonthlyCandidateJoinedData(res.data);
      });

    var year = [];
    for (var y = 2022; y <= new Date().getFullYear(); y++) {
      year.push(y);
    }
    setYears(year);
  }, []);

  const handleJobSelectedMonth = (key) => {
    setMonthByJob(key);
    let year = new Date().getFullYear();
    if (yearByJob?.length) {
      year = yearByJob;
    }
    fetch(
      `${constants.GetDailyJobDataUrl}?month=${
        months.indexOf(key) + 1
      }&year=${year}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${loggedInUser.sessionToken}`,
        },
      }
    )
      .then((response) => response.json())
      .then((res) => {
        var cvData = [];
        for (var x = 0; x <= Object.values(res.data); x++) {
          cvData.push(Object.values(res.data)[x]);
        }
        setDailyJobData(res.data);
        setIsDailyJobData(!isDailyJobData);
      });
  };

  const handleJobSelectedYear = (key) => {
    setYearByJob(key);
    let month = new Date().getMonth();
    if (monthByJob?.length) {
      month = months.indexOf(monthByJob);
    }

    fetch(
      `${constants.GetDailyJobDataUrl}?month=${Number(month) + 1}&year=${key}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${loggedInUser.sessionToken}`,
        },
      }
    )
      .then((response) => response.json())
      .then((res) => {
        var cvData = [];
        for (var x = 0; x <= Object.values(res.data); x++) {
          cvData.push(Object.values(res.data)[x]);
        }
        setDailyJobData(res.data);
        setIsDailyJobData(!isDailyJobData);
      });
  };

  const handleCandidatesSelectedMonth = (key) => {
    setMonthByAgent(key);
    let year = new Date().getFullYear();
    if (yearByAgent?.length) {
      year = yearByAgent;
    }

    fetch(
      `${constants.GetDailyCvAnalyticsUrl}?month=${
        months.indexOf(key) + 1
      }&year=${year}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${loggedInUser.sessionToken}`,
        },
      }
    )
      .then((response) => response.json())
      .then((res) => {
        var cvData = [];
        for (var x = 0; x <= Object.values(res.data); x++) {
          cvData.push(Object.values(res.data)[x]);
        }
        setDailyCvData(res.data);
        setIsDailyCvData(!isDailyCvData);
      });
  };

  const handleCandidatesSelectedYear = (key) => {
    setYearByAgent(key);
    let month = new Date().getMonth();
    if (monthByAgent?.length) {
      month = months.indexOf(monthByAgent);
    }
    fetch(
      `${constants.GetDailyCvAnalyticsUrl}?month=${month + 1}&year=${key}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${loggedInUser.sessionToken}`,
        },
      }
    )
      .then((response) => response.json())
      .then((res) => {
        var cvData = [];
        for (var x = 0; x <= Object.values(res.data); x++) {
          cvData.push(Object.values(res.data)[x]);
        }
        setDailyCvData(res.data);
        setIsDailyCvData(!isDailyCvData);
      });
  };

  const handleCandidatesByIRSelectedMonth = (key) => {
    setMonthByIr(key);
    let year = new Date().getFullYear();
    if (yearByIr?.length) {
      year = yearByIr;
    }

    fetch(
      `${constants.GetDailyCvByIRUrl}?month=${
        months.indexOf(key) + 1
      }&year=${year}&role=IR`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${loggedInUser.sessionToken}`,
        },
      }
    )
      .then((response) => response.json())
      .then((res) => {
        setDailyCvByIRData(res.data);
        setIsDailyCvByIr(!isDailyCvByIr);
      });
  };

  const handleCandidatesByIRSelectedYear = (key) => {
    setYearByIr(key);
    let month = new Date().getMonth();
    if (monthByIr?.length) {
      month = months.indexOf(monthByIr);
    }
    fetch(
      `${constants.GetDailyCvByIRUrl}?month=${month + 1}&year=${key}&role=IR`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${loggedInUser.sessionToken}`,
        },
      }
    )
      .then((response) => response.json())
      .then((res) => {
        setDailyCvByIRData(res.data);
        setIsDailyCvByIr(!isDailyCvByIr);
      });
  };

  const handleRecruiterByCandidateSelectedMonth = (key) => {
    setRecruitersMonthByCandidate(key);
    let year = new Date().getFullYear();
    if (recruitersYearByCandidate?.length) {
      year = recruitersYearByCandidate;
    }

    fetch(
      `${constants.TopRecruitersByCandidateUrl}?month=${
        months.indexOf(key) + 1
      }&year=${year}&topBy=candidateJoined`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${loggedInUser.sessionToken}`,
        },
      }
    )
      .then((response) => response.json())
      .then((res) => {
        var name = [];
        var percent = [];
        if (res?.data) {
          res?.data.map((rec) => name.push(rec.name));
          res?.data.map((rec) => percent.push(rec.percentage));
        }
        setTopRecruitersNameByCandidate(name);
        setTopRecruitersPercentByCandidate(percent);
        setIsRecruiterByCandidate(!isRecruiterByCandidate);
      });
  };

  const handleRecruiterByCandidateSelectedYear = (key) => {
    setRecruitersYearByCandidate(key);
    let month = new Date().getMonth();
    if (recruitersMonthByCandidate?.length) {
      month = months.indexOf(recruitersMonthByCandidate);
    }
    fetch(
      `${constants.TopRecruitersByCandidateUrl}?month=${
        month + 1
      }&year=${key}&topBy=candidateJoined`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${loggedInUser.sessionToken}`,
        },
      }
    )
      .then((response) => response.json())
      .then((res) => {
        var name = [];
        var percent = [];
        if (res?.data) {
          res?.data.map((rec) => name.push(rec.name));
          res?.data.map((rec) => percent.push(rec.percentage));
        }
        setTopRecruitersNameByCandidate(name);
        setTopRecruitersPercentByCandidate(percent);
        setIsRecruiterByCandidate(!isRecruiterByCandidate);
      });
  };

  const handleRecruiterByRevenueSelectedMonth = (key) => {
    setRecruitersMonthByRevenue(key);
    let year = new Date().getFullYear();
    if (recruitersYearByRevenue?.length) {
      year = recruitersYearByRevenue;
    }

    fetch(
      `${constants.TopRecruitersByCandidateUrl}?month=${
        months.indexOf(key) + 1
      }&year=${year}&topBy=revenueGenerated`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${loggedInUser.sessionToken}`,
        },
      }
    )
      .then((response) => response.json())
      .then((res) => {
        var name = [];
        var percent = [];
        if (res?.data) {
          res?.data.map((rec) => name.push(rec.name));
          res?.data.map((rec) => percent.push(rec.percentage));
        }
        setTopRecruitersNameByRevenue(name);
        setTopRecruitersPercentByRevenue(percent);
        setIsRecruiterByRevenue(!isRecruiterByRevenue);
      });
  };

  const handleRecruiterByRevenueSelectedYear = (key) => {
    setRecruitersYearByRevenue(key);
    let month = new Date().getMonth();
    if (recruitersMonthByRevenue?.length) {
      month = months.indexOf(recruitersMonthByRevenue);
    }
    fetch(
      `${constants.TopRecruitersByCandidateUrl}?month=${
        month + 1
      }&year=${key}&topBy=revenueGenerated`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${loggedInUser.sessionToken}`,
        },
      }
    )
      .then((response) => response.json())
      .then((res) => {
        var name = [];
        var percent = [];
        if (res?.data) {
          res?.data.map((rec) => name.push(rec.name));
          res?.data.map((rec) => percent.push(rec.percentage));
        }
        setTopRecruitersNameByRevenue(name);
        setTopRecruitersPercentByRevenue(percent);
        setIsRecruiterByRevenue(!isRecruiterByRevenue);
      });
  };

  const handleInternalByCandidateSelectedMonth = (key) => {
    setInternalMonthByCandidate(key);
    let year = new Date().getFullYear();
    if (internalYearByCandidate?.length) {
      year = internalYearByCandidate;
    }

    fetch(
      `${constants.TopInternalByCandidateUrl}?month=${
        months.indexOf(key) + 1
      }&year=${year}&topBy=candidateJoined`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${loggedInUser.sessionToken}`,
        },
      }
    )
      .then((response) => response.json())
      .then((res) => {
        var name = [];
        var percent = [];
        if (res?.data) {
          res?.data.map((rec) => name.push(rec.name));
          res?.data.map((rec) => percent.push(rec.percentage));
        }
        setTopInternalNameByCandidate(name);
        setTopInternalPercentByCandidate(percent);
        setIsInternalByCandidate(!isInternalByCandidate);
      });
  };

  const handleInternalByCandidateSelectedYear = (key) => {
    setInternalYearByCandidate(key);
    let month = new Date().getMonth();
    if (internalMonthByCandidate?.length) {
      month = months.indexOf(internalMonthByCandidate);
    }
    fetch(
      `${constants.TopInternalByCandidateUrl}?month=${
        month + 1
      }&year=${key}&topBy=candidateJoined`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${loggedInUser.sessionToken}`,
        },
      }
    )
      .then((response) => response.json())
      .then((res) => {
        var name = [];
        var percent = [];
        if (res?.data) {
          res?.data.map((rec) => name.push(rec.name));
          res?.data.map((rec) => percent.push(rec.percentage));
        }
        setTopInternalNameByCandidate(name);
        setTopInternalPercentByCandidate(percent);
        setIsInternalByCandidate(!isInternalByCandidate);
      });
  };

  return (
    <Fragment>
      <div className="row">
        <div className="col-xl-6">
          <div className="card">
            <div className="card-header border-0 pb-0 network-header">
              <p className="text-black mb-0">Jobs</p>
            </div>
            <div className="card-body pt-0 mr-2">
              <div className="row">
                <div className="col-xl-6 col-lg-6 col-xxl-12 col-sm-6">
                  {jobData && Object.keys(jobData).length !== 0 ? (
                    <PieChart
                      cvs={jobData.noOfJObHavingCVSubmitted}
                      offers={jobData.noOfJobHavingOfferReleased}
                      joined={jobData.noOfJobHavingCandidatesJoined}
                      notJoined={jobData.noOfJobHavingCandidatesNotJoined}
                      rejected={jobData.noOfJobHavingCandidatesRejected}
                      noCvs={jobData.noOfJobHaveNotCV}
                    />
                  ) : (
                    <p>No records found</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-6">
          <div className="card">
            <div className="card-header border-0 pb-0 network-header">
              <p className="text-black mb-0">Job Ageing</p>
            </div>
            <div className="card-body pt-0 mr-2">
              {statistics && Object.keys(statistics).length !== 0 ? (
                <JobAgeing statistics={statistics} />
              ) : (
                <p>No records found</p>
              )}
            </div>
          </div>
        </div>
        <div className="col-xl-6">
          <div className="card">
            <div className="card-header border-0 pb-0">
              <p className="text-black mb-0">Jobs Posted</p>
              <div className="flex-wrap">
                <DropdownButton
                  className="btn btn-sm"
                  id="dropdown-basic-button"
                  variant="success"
                  onSelect={handleJobSelectedYear}
                  title={yearByJob || new Date().getFullYear()}
                  style={{ color: "#00ADEE" }}
                >
                  {years?.map((year, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={year}>
                        {year}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
                <DropdownButton
                  id="dropdown-basic-button"
                  className="btn btn-sm"
                  variant="success"
                  onSelect={handleJobSelectedMonth}
                  title={monthByJob || months[new Date().getMonth()]}
                  style={{ color: "#00ADEE" }}
                >
                  {months?.map((month, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={month}>
                        {month}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </div>
            </div>
            <br />
            <div className="card-body pt-0 mr-2">
              <div className="row">
                {!isDailyJobData && (
                  <div className="col-xl-6 col-lg-6 col-xxl-12 col-sm-6">
                    {dailyJobData && Object.keys(dailyJobData).length !== 0 ? (
                      <SplineChart
                        data={Object.values(dailyJobData)}
                        dates={Object.keys(dailyJobData)}
                        name="Jobs"
                        color="#FD5F76"
                      />
                    ) : 
                    <p>No records found</p>
                    }
                  </div>
                )}
                {isDailyJobData && (
                  <div className="col-xl-6 col-lg-6 col-xxl-12 col-sm-6">
                    {dailyJobData && Object.keys(dailyJobData).length !== 0 ? (
                      <SplineChart
                        data={Object.values(dailyJobData)}
                        dates={Object.keys(dailyJobData)}
                        name="Jobs"
                        color="#FD5F76"
                      />
                    ) : (
                      <p>No records found</p>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-6">
          <div className="card">
            <div className="card-header border-0 pb-0 flex-wrap">
              <p className="text-black mb-0">
                Jobs Posted Every Month ({new Date().getFullYear()})
              </p>
            </div>
            <div className="card-body pb-0">
              {monthlyJobData && Object.keys(monthlyJobData).length !== 0 ? (
                <ChartBar data={monthlyJobData} name="Jobs" color="#8743DF" />
              ) : (
                <p>No records found</p>
              )}
            </div>
          </div>
        </div>

        <div className="col-xl-6">
          <div className="card">
            <div className="card-header border-0 pb-0">
              <p className="text-black mb-0">Candidates By Agent</p>
              <div className="flex-wrap">
                <DropdownButton
                  className="btn btn-sm"
                  id="dropdown-basic-button"
                  variant="success"
                  onSelect={handleCandidatesSelectedYear}
                  title={yearByAgent || new Date().getFullYear()}
                  style={{ color: "#00ADEE" }}
                >
                  {years?.map((year, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={year}>
                        {year}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
                <DropdownButton
                  id="dropdown-basic-button"
                  className="btn btn-sm"
                  variant="success"
                  onSelect={handleCandidatesSelectedMonth}
                  title={monthByAgent || months[new Date().getMonth()]}
                  style={{ color: "#00ADEE" }}
                >
                  {months?.map((month, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={month}>
                        {month}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </div>
            </div>
            <br />
            <div className="card-body pt-0 mr-2">
              <div className="row">
                {!isDailyCvData && (
                  <div className="col-xl-6 col-lg-6 col-xxl-12 col-sm-6">
                    {dailyCvData && Object.keys(dailyCvData).length !== 0 ? (
                      <SplineChart
                        data={Object.values(dailyCvData)}
                        dates={Object.keys(dailyCvData)}
                        name="Candidates"
                        color="#2BC155"
                      />
                    ) : (
                      <p>No records found</p>
                    )}
                  </div>
                )}
                {isDailyCvData && (
                  <div className="col-xl-6 col-lg-6 col-xxl-12 col-sm-6">
                    {dailyCvData && Object.keys(dailyCvData).length !== 0 ? (
                      <SplineChart
                        data={Object.values(dailyCvData)}
                        dates={Object.keys(dailyCvData)}
                        name="Candidates"
                        color="#2BC155"
                      />
                    ) : (
                      <p>No records found</p>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-6">
          <div className="card">
            <div className="card-header border-0 pb-0">
              <p className="text-black mb-0">Candidates By Internal Team</p>
              <div className="flex-wrap">
                <DropdownButton
                  className="btn btn-sm"
                  id="dropdown-basic-button"
                  variant="success"
                  onSelect={handleCandidatesByIRSelectedYear}
                  title={yearByIr || new Date().getFullYear()}
                  style={{ color: "#00ADEE" }}
                >
                  {years?.map((year, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={year}>
                        {year}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
                <DropdownButton
                  id="dropdown-basic-button"
                  className="btn btn-sm"
                  variant="success"
                  onSelect={handleCandidatesByIRSelectedMonth}
                  title={monthByIr || months[new Date().getMonth()]}
                  style={{ color: "#00ADEE" }}
                >
                  {months?.map((month, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={month}>
                        {month}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </div>
            </div>
            <br />
            <div className="card-body pt-0 mr-2">
              <div className="row">
                {!isDailyCvByIr && (
                  <div className="col-xl-6 col-lg-6 col-xxl-12 col-sm-6">
                    {dailyCvByIRData &&
                    Object.keys(dailyCvByIRData).length !== 0 ? (
                      <SplineChart
                        data={Object.values(dailyCvByIRData)}
                        dates={Object.keys(dailyCvByIRData)}
                        name="Candidates"
                        color="#FF9B52"
                      />
                    ) : (
                      <p>No records found</p>
                    )}
                  </div>
                )}
                {isDailyCvByIr && (
                  <div className="col-xl-6 col-lg-6 col-xxl-12 col-sm-6">
                    {dailyCvByIRData &&
                    Object.keys(dailyCvByIRData).length !== 0 ? (
                      <SplineChart
                        data={Object.values(dailyCvByIRData)}
                        dates={Object.keys(dailyCvByIRData)}
                        name="Candidates"
                        color="#FF9B52"
                      />
                    ) : (
                      <p>No records found</p>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-6">
          <div className="card">
            <div className="card-header border-0 pb-0 flex-wrap">
              <p className="text-black mb-0">Candidates Applied</p>
            </div>
            <div className="card-body pb-0">
              {monthlyCvData && Object.keys(monthlyCvData).length !== 0 ? (
                <ChartBar
                  data={monthlyCvData}
                  name="Candidates"
                  color="#2BC155"
                />
              ) : (
                <p>No records found</p>
              )}
            </div>
          </div>
        </div>
        <div className="col-xl-6">
          <div className="card">
            <div className="card-header border-0 pb-0 flex-wrap">
              <p className="text-black mb-0">Candidates Joined</p>
            </div>
            <div className="card-body pb-0">
              {monthlyCandidateJoinedData &&
              Object.keys(monthlyCandidateJoinedData).length !== 0 ? (
                <ChartBar
                  data={monthlyCandidateJoinedData}
                  name="Candidates Joined"
                  color="#FF9B52"
                />
              ) : (
                <p>No records found</p>
              )}
            </div>
          </div>
        </div>
        <div className="col-xl-6">
          <div className="card">
            <div className="card-header border-0 pb-0 flex-wrap">
              <p className="text-black mb-0">Revenue Generated</p>
            </div>
            <div className="card-body pb-0">
              {monthlyRevenueGenerated &&
              Object.keys(monthlyRevenueGenerated).length !== 0 ? (
                <ChartBar
                  data={monthlyRevenueGenerated}
                  name="Revenue Generated"
                  color="#F0FFFF"
                />
              ) : (
                <p>No records found</p>
              )}
            </div>
          </div>
        </div>
        <div className="col-xl-6">
          <div className="card">
            <div className="card-header border-0 pb-0 network-header">
              <p className="text-black mb-0">Top Companies</p>
            </div>
            <div className="card-body pt-0 mr-2">
              <div className="row">
                <div className="col-xl-6 col-lg-6 col-xxl-12 col-sm-6">
                  {topCompanies && Object.keys(topCompanies).length !== 0 ? (
                    <MultipleRadialBar
                      x={Object.keys(topCompanies)}
                      y={Object.values(topCompanies)}
                    />
                  ) : (
                    <p>No records found</p>
                  )}
                </div>
                <p>Based on the Jobs posted</p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-6">
          <div className="card">
            <div className="card-header border-0 pb-0 network-header">
              <p className="text-black mb-0">Top Companies</p>
            </div>
            <div className="card-body pt-0 mr-2">
              <div className="row">
                <div className="col-xl-6 col-lg-6 col-xxl-12 col-sm-6">
                  {higherRevenue && Object.keys(higherRevenue).length !== 0 ? (
                    <MultipleRadialBar
                      x={Object.keys(higherRevenue)}
                      y={Object.values(higherRevenue)}
                    />
                  ) : (
                    <p>No records found</p>
                  )}
                </div>
                <p>Based on Revenue Generated</p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-6">
          <div className="card">
            <div className="card-header border-0 pb-0 network-header">
              <p className="text-black mb-0">Top Recruiters</p>
              <div className="flex-wrap">
                <DropdownButton
                  className="btn btn-sm"
                  id="dropdown-basic-button"
                  variant="success"
                  onSelect={handleRecruiterByCandidateSelectedYear}
                  title={recruitersYearByCandidate || new Date().getFullYear()}
                  style={{ color: "#00ADEE" }}
                >
                  {years?.map((year, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={year}>
                        {year}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
                <DropdownButton
                  id="dropdown-basic-button"
                  className="btn btn-sm"
                  variant="success"
                  onSelect={handleRecruiterByCandidateSelectedMonth}
                  title={
                    recruitersMonthByCandidate || months[new Date().getMonth()]
                  }
                  style={{ color: "#00ADEE" }}
                >
                  {months?.map((month, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={month}>
                        {month}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </div>
            </div>
            <div className="card-body pt-0 mr-2">
              <div className="row">
                {!isRecruiterByCandidate && (
                  <div className="col-xl-6 col-lg-6 col-xxl-12 col-sm-6">
                    {topRecruitersNameByCandidate &&
                    Object.keys(topRecruitersNameByCandidate).length !== 0 &&
                    topRecruitersPercentByCandidate &&
                    Object.keys(topRecruitersPercentByCandidate).length !==
                      0 ? (
                      <MultipleRadialBar
                        x={topRecruitersNameByCandidate}
                        y={topRecruitersPercentByCandidate}
                      />
                    ) : (
                      <p>No records found</p>
                    )}
                  </div>
                )}
                {isRecruiterByCandidate && (
                  <div className="col-xl-6 col-lg-6 col-xxl-12 col-sm-6">
                    {topRecruitersNameByCandidate &&
                    Object.keys(topRecruitersNameByCandidate).length !== 0 &&
                    topRecruitersPercentByCandidate &&
                    Object.keys(topRecruitersPercentByCandidate).length !==
                      0 ? (
                      <MultipleRadialBar
                        x={topRecruitersNameByCandidate}
                        y={topRecruitersPercentByCandidate}
                      />
                    ) : (
                      <p>No records found</p>
                    )}
                  </div>
                )}
                <p>Based on Candidates Joined</p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-6">
          <div className="card">
            <div className="card-header border-0 pb-0 network-header">
              <p className="text-black mb-0">Top Recruiters</p>
              <div className="flex-wrap">
                <DropdownButton
                  className="btn btn-sm"
                  id="dropdown-basic-button"
                  variant="success"
                  onSelect={handleRecruiterByRevenueSelectedYear}
                  title={recruitersYearByRevenue || new Date().getFullYear()}
                  style={{ color: "#00ADEE" }}
                >
                  {years?.map((year, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={year}>
                        {year}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
                <DropdownButton
                  id="dropdown-basic-button"
                  className="btn btn-sm"
                  variant="success"
                  onSelect={handleRecruiterByRevenueSelectedMonth}
                  title={
                    recruitersMonthByRevenue || months[new Date().getMonth()]
                  }
                  style={{ color: "#00ADEE" }}
                >
                  {months?.map((month, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={month}>
                        {month}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </div>
            </div>
            <div className="card-body pt-0 mr-2">
              <div className="row">
                {!isRecruiterByRevenue && (
                  <div className="col-xl-6 col-lg-6 col-xxl-12 col-sm-6">
                    {topRecruitersNameByRevenue &&
                    Object.keys(topRecruitersNameByRevenue).length !== 0 &&
                    topRecruitersPercentByRevenue &&
                    Object.keys(topRecruitersPercentByRevenue).length !== 0 ? (
                      <MultipleRadialBar
                        x={topRecruitersNameByRevenue}
                        y={topRecruitersPercentByRevenue}
                      />
                    ) : (
                      <p>No records found</p>
                    )}
                  </div>
                )}
                {isRecruiterByRevenue && (
                  <div className="col-xl-6 col-lg-6 col-xxl-12 col-sm-6">
                    {topRecruitersNameByRevenue &&
                    Object.keys(topRecruitersNameByRevenue).length !== 0 &&
                    topRecruitersPercentByRevenue &&
                    Object.keys(topRecruitersPercentByRevenue).length !== 0 ? (
                      <MultipleRadialBar
                        x={topRecruitersNameByRevenue}
                        y={topRecruitersPercentByRevenue}
                      />
                    ) : (
                      <p>No records found</p>
                    )}
                  </div>
                )}
                <p>Based on Revenue Generated</p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-6">
          <div className="card">
            <div className="card-header border-0 pb-0 network-header">
              <p className="text-black mb-0">Top Internal Team</p>
              <div className="flex-wrap">
                <DropdownButton
                  className="btn btn-sm"
                  id="dropdown-basic-button"
                  variant="success"
                  onSelect={handleInternalByCandidateSelectedYear}
                  title={internalYearByCandidate || new Date().getFullYear()}
                  style={{ color: "#00ADEE" }}
                >
                  {years?.map((year, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={year}>
                        {year}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
                <DropdownButton
                  id="dropdown-basic-button"
                  className="btn btn-sm"
                  variant="success"
                  onSelect={handleInternalByCandidateSelectedMonth}
                  title={
                    internalMonthByCandidate || months[new Date().getMonth()]
                  }
                  style={{ color: "#00ADEE" }}
                >
                  {months?.map((month, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={month}>
                        {month}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </div>
            </div>
            <div className="card-body pt-0 mr-2">
              <div className="row">
                {!isInternalByCandidate && (
                  <div className="col-xl-6 col-lg-6 col-xxl-12 col-sm-6">
                    {topInternalNameByCandidate &&
                    Object.keys(topInternalNameByCandidate).length !== 0 &&
                    topInternalPercentByCandidate &&
                    Object.keys(topInternalPercentByCandidate).length !== 0 ? (
                      <MultipleRadialBar
                        x={topInternalNameByCandidate}
                        y={topInternalPercentByCandidate}
                      />
                    ) : (
                      <p>No records found</p>
                    )}
                  </div>
                )}
                {isInternalByCandidate && (
                  <div className="col-xl-6 col-lg-6 col-xxl-12 col-sm-6">
                    {topInternalNameByCandidate &&
                    Object.keys(topInternalNameByCandidate).length !== 0 &&
                    topInternalPercentByCandidate &&
                    Object.keys(topInternalPercentByCandidate).length !== 0 ? (
                      <MultipleRadialBar
                        x={topInternalNameByCandidate}
                        y={topInternalPercentByCandidate}
                      />
                    ) : (
                      <p>No records found</p>
                    )}
                  </div>
                )}
                <p>Based on Candidates Joined</p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-6">
          <div className="card">
            <div className="card-header border-0 pb-0 network-header">
              <p className="text-black mb-0">Top Industries</p>
            </div>
            <div className="card-body pt-0 mr-2">
              <div className="row">
                <div className="col-xl-6 col-lg-6 col-xxl-12 col-sm-6">
                  {topIndustries && Object.keys(topIndustries).length !== 0 ? (
                    <MultipleRadialBar
                      x={Object.keys(topIndustries)}
                      y={Object.values(topIndustries)}
                    />
                  ) : (
                    <p>No records found</p>
                  )}
                </div>
                <p>Based on Jobs Posted</p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-6">
          <div className="card">
            <div className="card-header border-0 pb-0 network-header">
              <p className="text-black mb-0">Recruiters with Higher Backout</p>
            </div>
            <div className="card-body pt-0 mr-2">
              <div className="row">
                <div className="col-xl-6 col-lg-6 col-xxl-12 col-sm-6">
                  {higherBackout && Object.keys(higherBackout).length !== 0 ? (
                    <MultipleRadialBar
                      x={Object.keys(higherBackout)}
                      y={Object.values(higherBackout)}
                    />
                  ) : (
                    <p>No records found</p>
                  )}
                </div>
                <p>Based on Candidates not Joined</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Statistics;
